export default {
  categorias: [],
  categoria: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
